import React from 'react';
import { Link } from 'react-router-dom';
import { services, industries } from '../mockData';

const Sitemap = () => {
  return (
    <div className="min-h-screen">
      <section className="bg-gradient-to-br from-indigo-600 via-purple-600 to-indigo-800 text-white py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold">Sitemap</h1>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Main Pages */}
          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-4">Main Pages</h2>
            <ul className="space-y-2">
              <li><Link to="/" className="text-indigo-600 hover:text-indigo-700">Home</Link></li>
              <li><Link to="/contact" className="text-indigo-600 hover:text-indigo-700">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-4">Services</h2>
            <ul className="space-y-2">
              <li><Link to="/services" className="text-indigo-600 hover:text-indigo-700">All Services</Link></li>
              {services.map(service => (
                <li key={service.id}>
                  <Link to={`/services/${service.slug}`} className="text-indigo-600 hover:text-indigo-700 text-sm">
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-4">Industries</h2>
            <ul className="space-y-2">
              <li><Link to="/industries" className="text-indigo-600 hover:text-indigo-700">All Industries</Link></li>
              {industries.map(industry => (
                <li key={industry.id}>
                  <Link to={`/industries/${industry.slug}`} className="text-indigo-600 hover:text-indigo-700 text-sm">
                    {industry.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-4">Company</h2>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-indigo-600 hover:text-indigo-700">About</Link></li>
              <li><Link to="/about/leadership" className="text-indigo-600 hover:text-indigo-700">Leadership</Link></li>
              <li><Link to="/about/locations" className="text-indigo-600 hover:text-indigo-700">Locations</Link></li>
              <li><Link to="/about/awards" className="text-indigo-600 hover:text-indigo-700">Awards</Link></li>
              <li><Link to="/about/esg" className="text-indigo-600 hover:text-indigo-700">ESG</Link></li>
              <li><Link to="/about/diversity" className="text-indigo-600 hover:text-indigo-700">Diversity</Link></li>
              <li><Link to="/about/innovation-lab" className="text-indigo-600 hover:text-indigo-700">Innovation Lab</Link></li>
              <li><Link to="/client-success" className="text-indigo-600 hover:text-indigo-700">Client Success</Link></li>
              <li><Link to="/insights" className="text-indigo-600 hover:text-indigo-700">Insights</Link></li>
              <li><Link to="/partner-ecosystem" className="text-indigo-600 hover:text-indigo-700">Partners</Link></li>
              <li><Link to="/careers" className="text-indigo-600 hover:text-indigo-700">Careers</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sitemap;